import React from "react";
import moment from 'moment';
import MonthPicker from '../month-picker'
import {    getDeclarationReportPDF, 
            getFullMonthFormat, 
            getEmployerStatementPDF, 
            getAccountStatementPDF,
            getJournalBankMessagesPDF } from '../../utils'
import { SvgDownloadIcon } from '../svg';


class DeclarationReport extends React.Component {
    constructor(props) {
        super(props)

        let then = moment.utc().subtract(1, 'year')
        let now = moment.utc()

        this.state = {
            mrange: {from: {year: then.year(), month: then.month()+1}, to: {year: now.year(), month: now.month()+1}},
        }

    }

    getDeclarationReport(id, elementId, e) {
        e.stopPropagation();
        e.preventDefault();

        $(elementId).show()

        let mrange = this.state.mrange;

        let dateFrom = mrange.from.year + '-' + getFullMonthFormat(mrange.from.month) + '-01';
        let dateTo = mrange.to.year + '-' + getFullMonthFormat(mrange.to.month) + '-01';
        if (this.props.declarationType === "employer_declaration") {
            getEmployerStatementPDF(id, dateFrom, dateTo, elementId)
        } else if (this.props.declarationType === "employer_account") { 
            getAccountStatementPDF(id, dateFrom, dateTo, elementId)
        } else if (this.props.declarationType === "customer_declaration") {
            getDeclarationReportPDF(id, dateFrom, dateTo, elementId)
        } else if (this.props.declarationType === "customer_journal") { 
            getJournalBankMessagesPDF(id, dateFrom, dateTo, elementId)
        }
    }

    updateRange(value) {
        this.setState({
            mrange: value
        })
    }

    updateFrom(value) {
        let state = {...this.state}
        state.mrange.from = value
        this.setState(state)
    }

    updateTo(value) {
        let state = {...this.state}
        state.mrange.to = value
        this.setState(state)
    }

    render() {
        return (
            <>
                <MonthPicker mrange={this.state.mrange} updateRange={this.updateRange.bind(this)} updateFrom={this.updateFrom.bind(this)} updateTo={this.updateTo.bind(this)}/>
                <button className="btn btn-warning xs-p-10" onClick={this.getDeclarationReport.bind(this, this.props.id, `#declaration-${this.props.declarationType}-${this.props.id}`)}>
                    <SvgDownloadIcon/>
                    Sækja yfirlit
                    <i style={{display: 'none'}} id={`declaration-${this.props.declarationType}-${this.props.id}`} className="fa fa-spin fa-sync-alt xs-ml-10" />
                </button>
                <div id={`declaration-${this.props.declarationType}-${this.props.id}-error`} className="xs-pt-20 text-center"></div>
            </>
        )
    }
}

export default DeclarationReport;